import { render, staticRenderFns } from "./TabsCard.vue?vue&type=template&id=b3dca4d0"
import script from "./TabsCard.vue?vue&type=script&lang=js"
export * from "./TabsCard.vue?vue&type=script&lang=js"
import style0 from "./TabsCard.vue?vue&type=style&index=0&id=b3dca4d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports